import { ActionIcon, Tooltip } from '@mantine/core';
import {
  IconAlertTriangle,
  IconCalendarPause,
  IconCheck,
  IconLoader,
  IconX,
} from '@tabler/icons-react';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

import classes from './status-cell.module.css';

import { FORM_STATUS } from '@data-access';

export const STYLES = {
  [FORM_STATUS.FINISHED]: {
    icon: IconCheck,
    color: 'pf-green',
  },
  [FORM_STATUS.INCOMPLETE]: {
    icon: IconX,
    color: 'red',
  },
  [FORM_STATUS.WAITING]: {
    icon: IconCalendarPause,
    color: 'gray.6',
  },
  [FORM_STATUS.NO_MODULATION]: {
    icon: IconCheck,
    color: 'gray.6',
  },
  [FORM_STATUS.PENDING]: {
    icon: IconLoader,
    color: 'yellow',
  },
  [FORM_STATUS.ERROR]: {
    icon: IconAlertTriangle,
    color: 'orange',
  },
};

export interface StatusCellProps {
  status: FORM_STATUS;
  onClick?: () => void;
}

export const StatusCell = forwardRef<any, StatusCellProps>((props, ref) => {
  const { t } = useTranslation();

  if (props.status === FORM_STATUS.REJECTED || !STYLES[props.status]) {
    return 'not implemented';
  }

  const Icon = STYLES[props.status].icon;
  const color = STYLES[props.status].color;
  const label = t(`common.${props.status}`, { defaultValue: props.status });

  return (
    <Tooltip label={label} withArrow>
      <ActionIcon
        aria-label={label}
        className={classes.button}
        color={color}
        component={props.onClick ? 'button' : 'div'}
        disabled={!props.onClick}
        onClick={props.onClick}
        radius="md"
        ref={ref}
        size="md"
        variant="filled"
      >
        <Icon stroke={3.5} style={{ width: '80%', height: '80%' }} />
      </ActionIcon>
    </Tooltip>
  );
});

export default StatusCell;
